<template>
  <info> </info>
</template>

<script>
import info from './info'
export default {
  components: { info },
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style scoped></style>
